import React, { useState } from "react";
import "./TeenPattiChaalHistory.css";
import { Button, Modal } from "react-bootstrap";
import RummyTableHistoryInnerRoundCards from "../RummyTableHistoryInnerRoundCards/RummyTableHistoryInnerRoundCards";

function TeenPattiChaalHistory(props) {
  const [rummyWalletHistoryCards, setRummyWalletHistoryCards] = useState([]);

  const [showRummyWalletHistory, setShowRummyWalletHistory] = useState(false);

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Player Chaal History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="rummy-history-table-wrapper">
            <table className="rummy-history-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Round No</th>
                  <th>Points</th>
                  <th>Time</th>
                </tr>
              </thead>

              <tbody>
                {props?.chaalHistory?.length > 0 ? (
                  props.chaalHistory.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.type}</td>
                      <td>{item.amount || "-"} points</td>
                      <td>
                        {new Date(item.createdAt).toLocaleString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })}
                      </td>{" "}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="no-history">
                      No round history found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <RummyTableHistoryInnerRoundCards
        onHide={() => setShowRummyWalletHistory(false)}
        show={showRummyWalletHistory}
        rummyWalletHistoryCards={rummyWalletHistoryCards}
      />
    </div>
  );
}

export default TeenPattiChaalHistory;
